<div *ngIf="authorizedUrl()" class="help-me-tab" [class.closed]="isClosed">
  <div class="help-me-container">
    <div class="button-wrapper">
      <div class="button" (click)="onTabClick()" [class.badged]="badged">
        <i i-bs name="chat-fill"></i>
      </div>
    </div>
    <div class="content">
      <ng-container *ngIf="!isLoading else loader">
        <msd-message-help *ngFor="let message of messageHelp" [message]="message" (refresh)="loadMessage()">
        </msd-message-help>

        <msd-faq-help *ngFor="let faq of faqHelp" [faq]="faq">
        </msd-faq-help>
      </ng-container>
      <ng-template #loader>
        <ngx-inner-loading [loadingDescription]="'Chargement...'"
                           [loading]="isLoading"
                           class="flex-center">
        </ngx-inner-loading>
      </ng-template>

      <div *ngIf="!isLoading" class="faq">
        <div class="faq-title">Vous rencontrez un problème ?</div>
        <div class="faq-content">
          <ng-container *ngIf="!hasMessager else messagerLayout">
            <a (click)="openMessager()">Cliquez-ici</a>, afin de faire parvenir à l'équipe MonSuiviDiet, un message
            expliquant votre point de blocage.
          </ng-container>
          <ng-template #messagerLayout>
            <div class="messager-wrapper">
              <div class="messager-category">
                <select class="form-control custom-select" [(ngModel)]="category" [disabled]="submitted">
                  <option [ngValue]="undefined" disabled>Choisir une catégorie...</option>
                  <ng-container *ngFor="let cat of HelpMeCategoriesTools.getAllValues()">
                    <option *ngIf="displayCategory(cat)" [ngValue]="cat">{{getLabelCategory(cat)}}</option>
                  </ng-container>
                </select>
              </div>
              <div class="messager-text">
                <textarea
                  [(ngModel)]="content"
                  [disabled]="submitted"
                  aria-describedby="content"
                  class="form-control"
                  id="message-textarea"
                  placeholder="Votre message..."
                  rows="3"
                  type="text"></textarea>
              </div>
              <div *ngIf="!hasContentValid()" class="d-flex w-100 justify-content-end">
                <small>Texte invalide ou vide (max 4000 car.)!</small>
              </div>
              <ng-container *ngIf="!unauthenticatedUrl()">
                <input #fileInput hidden id="fileInput" type="file" [accept]="acceptedFiles"
                       (change)="addAttachment($event)">
                <div class="messager-attachment">
                  <div *ngIf="attachments && attachments.length > 0">
                    <div class="attachment" *ngFor="let attachment of attachments">
                      <ng-container *ngIf="attachment.status === 'init'">
                        <div class="label-attachment">
                          <i i-bs [name]="'file-earmark'"></i><span>{{ attachment.name }}</span>
                        </div>
                        <div class="action-attachment" (click)="removeAttachment(attachment)">
                          <i i-bs [name]="'trash-fill'"></i>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="attachment.status === 'started'">
                        <div class="progress-attachment">
                          <progressbar *ngIf="(attachment.progress | async) !== -1" [value]="(attachment.progress | async) ?? -1" [type]="attachment.error ? 'danger' : 'info'" [animate]="true">{{ (attachment.progress | async) | number: '1.0-0' }}%</progressbar>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="attachment.status === 'completed'">
                        <div class="label-attachment">
                          <i i-bs [name]="'file-earmark'"></i><span>{{ attachment.name }} : 100%</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <a *ngIf="!submitted" (click)="fileInput.click()">
                    <i i-bs name="plus-square"></i><span>Attacher un fichier image</span>
                  </a>
                </div>
              </ng-container>
              <div class="messager-action">
                <button (click)="closeMessager()"
                        [disabled]="submitted"
                        class="btn btn-outline-primary btn-outline text-only"
                        type="button">Annuler
                </button>
                <button (click)="postMessager()" [disabled]="!enablePostMessager() || submitted"
                        class="btn btn-primary btn-gradient">Envoyer
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

